import { Body } from "@hypercard/web-components";
import { DashboardTile } from "../components/DashboardTile";
import { TileHeader } from "../components/TileHeader";
import { CreditCard } from "@phosphor-icons/react";
import { IconBox } from "@common/components";

export const LastTransactionsPromoTile = () => {
  return (
    <DashboardTile className="flex min-h-[350px] flex-col justify-between">
      <TileHeader>LAST TRANSACTIONS</TileHeader>
      <div className="flex h-full flex-col items-center justify-center overflow-hidden pb-8">
        <IconBox>
          <CreditCard className="size-8" />
        </IconBox>
        <Body
          size="lg"
          weight="medium"
          className="mt-6 text-pretty text-center"
        >
          Instant Reimbursements and 3X Points
        </Body>
        <Body
          size="sm"
          weight="regular"
          className="mx-2 mt-2 whitespace-pre-line text-pretty text-center text-white/70"
        >
          {"Get instantly reimbursed on your company expenses."}
        </Body>
      </div>
    </DashboardTile>
  );
};
